import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Page} from '@/app/core/models/page';
import {EventCalendar, EventType} from '@/app/core/models/calendar/eventCalendar';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';

@Injectable({
	providedIn: 'root'
})
export class MatchService {

	constructor(
		private readonly http: HttpClient
	) {}

	getCurrentEventCalendar(): Observable<EventCalendar> {
		return this.http.get<EventCalendar>(`${environment.backendUrl}/calendar/current`);
	}

	get5UpcomingMatches(): Observable<CalendarGroupByDate[]> {
		return this.http.get<CalendarGroupByDate[]>(`${environment.backendUrl}/calendar/upcoming/5`);
	}

	getUpcomingMatches(page: number, filter: string[]): Observable<Page<CalendarGroupByDate>> {
		console.log(filter)
		return this.http.get<Page<CalendarGroupByDate>>(`${environment.backendUrl}/calendar/upcoming?page=${page}&filters=${filter}`);
	}

	getResultMatches(page: number, filter: string[]): Observable<Page<CalendarGroupByDate>> {
		return this.http.get<Page<CalendarGroupByDate>>(`${environment.backendUrl}/calendar/result?page=${page}&filters=${filter}`);
	}

	getUpcomingMatchesByEventType(eventType: EventType): Observable<CalendarGroupByDate[]> {
		return this.http.get<CalendarGroupByDate[]>(`${environment.backendUrl}/calendar/upcoming/type/${eventType}`);
	}
}
